import axios from 'axios';
import {
	// getCompanyData,
	getProfessionalData,
	removeAdminData,
	removeCompanyData,
	removeProfessionalData,
	removeUserData,
} from '@/utils/cookies';
import { clearMatchResultLocally } from '@/utils/matchHandoff';

const api = axios.create({
	baseURL: import.meta.env.VITE_BACKEND_URL.replace(/\/$/, ''),
	withCredentials: true,
	headers: {
		'Content-Type': 'application/json',
		Accept: 'application/json',
	},
});

api.interceptors.response.use(
	(response) => response,
	async (error) => {
		const originalRequest = error.config;
		const pathname = window.location.pathname;
		const requestUrl = String(originalRequest?.url ?? '');
		const isAuthLoginPage =
			pathname === '/login' ||
			pathname === '/profissional/login' ||
			pathname === '/admin/login' ||
			pathname === '/empresa/login'; // rota inexistente (404); evita loop se alguém acessar a URL antiga
		/** Falha no POST de login nunca redireciona (igual user/admin/profissional). */
		const isAuthLoginRequest =
			requestUrl.endsWith('/login') ||
			requestUrl.includes('/auth/login') ||
			requestUrl.includes('/employees/login');

		const isCompanyFormularioPage = pathname.startsWith(
			'/empresa/formulario/',
		);
		/** /match é público: 401 em GET /match/me só significa "visitante" — a página trata. */
		const isMatchPage =
			pathname === '/match' || pathname.startsWith('/match/');

		if (error.response?.status === 401 || error.response?.status === 403) {
			/** Formulário público: 401 esperado (ex. GET empresa sem sessão) — não recarregar a página. */
			if (isCompanyFormularioPage || isMatchPage) {
				return Promise.reject(error);
			}

			if (
				!originalRequest._retry &&
				!isAuthLoginPage &&
				!isAuthLoginRequest
			) {
				originalRequest._retry = true;

				const professionalData = getProfessionalData();
				// const companyData = getCompanyData();

				let loginUrl = '/login';

				// Portal empresa com login desativado — colaborador: só /empresa/formulario (sem sessão empresa).
				// if (pathname.startsWith('/empresa') || companyData) {
				//   loginUrl = '/empresa/login';
				// }
				if (pathname.startsWith('/empresa')) {
					loginUrl = '/__portal-empresa-desativado__';
				} else if (
					pathname.startsWith('/profissional') ||
					professionalData
				) {
					loginUrl = '/profissional/login';
				} else if (pathname.startsWith('/admin')) {
					loginUrl = '/admin/login';
				}

				removeProfessionalData();
				removeUserData();
				removeAdminData();
				removeCompanyData();
				clearMatchResultLocally();

				window.location.href = loginUrl;
			}
		}

		return Promise.reject(error);
	},
);

export default api;
